import EventDashboard from './EventDashboard.vue'

export const routes = [
  {
    path: '/dashboard',
    name: 'event-dashboard',
    component: EventDashboard,
    meta: {
      requiresAuth: true,
      title: 'Dashboard'
    }
  }
]
